import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OfflineService } from '../../services/shared/offline/offline.service';
import { MatDialog } from '@angular/material/dialog';
import { openOfflineModal } from '../../shared/components/modal/offline-dialog/offline-dialog.component';

export const offlineGuard: CanActivateFn = (route, state) => {
  const dialog = inject(MatDialog);

  if (navigator.onLine) {
    return true;
  }

  const currentPath = state.url;

  if (
    currentPath.includes('/registers/point-of-sales') ||
    currentPath.includes('/registers/open-close-register')
  ) {
    return true;
  }

  // TODO: Move logic outside guard
  const existingDialog = dialog.getDialogById('offline-modal');
  if (!existingDialog) {
    openOfflineModal(dialog);
  }
  return false;
};
